import { provider } from "@grassrootly/api/providers";
import type {
  GetPlayerMonthlyFormPayload,
  PlayerMonthlyFormRow,
} from "@grassrootly/api/providers/supabase-provider/actions/GetPlayerMonthlyForm";

export { PlayerMonthlyFormRow };
export type { GetPlayerMonthlyFormPayload };

export const GetPlayerMonthlyForm = async (
  params: GetPlayerMonthlyFormPayload
): Promise<PlayerMonthlyFormRow[]> => provider.Request("/player-monthly-form", params);
